export const setSchoolDataMixin = {
  data() {
    return { financingTypeMap: { true: 1, false: 2, undefined: 3 } };
  },
  methods: {
    // @vuese
    // Aktualizuje dane szkoły
    updateSchoolData(selectedSchool) {
      if (selectedSchool.parentId) {
        this.updateWholeSchoolData(selectedSchool);
      } else {
        this.updateParentSchoolData(selectedSchool);
      }
    },

    // @vuese
    // Ustawia dane zespołu
    updateParentSchoolData(selectedSchool) {
      this.setSchoolData(selectedSchool);
      this.clearSubschoolData();

      this.subSearch().then(result => {
        if (result.list.length === 1) {
          this.updateSubschoolData(result.list[0]);
        } else {
          this.suboptions = result.list;
        }
      });
    },

    // @vuese
    // Ustawia dane szkoły i zespołu
    updateWholeSchoolData(selectedSchool) {
      if (selectedSchool.isSingle) {
        this.setSchoolData(selectedSchool, true);
      } else {
        this.setGroup(selectedSchool);
        this.updateSubschoolData(selectedSchool);
      }
    },

    // @vuese
    // Ustawia dane szkoły wybranej na drugim poziomie
    updateSubschoolData(selectedSchool) {
      this.schoolModel.subSchoolName.$setData(selectedSchool.name);
      this.schoolModel.subSchoolId.$setData(selectedSchool.id);
      this.schoolModel.schoolTypeDescription.$setData(selectedSchool.typeDescription);
      this.schoolModel.reportType.$setData(selectedSchool.data.reportType);
      this.setSchoolType(selectedSchool);
    },

    // @vuese
    // Ustawia dane głównej placówki
    setSchoolData(selectedSchool, isSubschool = false) {
      this.schoolModel.schoolName.$setData(selectedSchool.name);
      this.schoolModel.nodeId.$setData(selectedSchool.id);
      this.schoolModel.financingType.$setData(this.financingTypeMap[selectedSchool.isGuided]);
      this.setSchoolAddress(selectedSchool);

      this.schoolModel.isGroup.$setData(!isSubschool);
      if (isSubschool) {
        this.schoolModel.schoolTypeDescription.$setData(selectedSchool.typeDescription);
        this.schoolModel.reportType.$setData(selectedSchool.data.reportType);
        this.setSchoolType(selectedSchool);
      }
    },

    // @vuese
    // Ustawia typ szkoły
    setSchoolType(selectedSchool) {
      if (selectedSchool.isSchool) {
        this.schoolModel.schoolType.$setData(1);
      } else if (selectedSchool.isCollege) {
        this.schoolModel.schoolType.$setData(2);
      } else {
        this.schoolModel.schoolType.$setData(3);
      }
    },

    // @vuese
    // Ustawia adres szkoły
    setSchoolAddress(selectedSchool) {
      const selectedAddress = selectedSchool.data.address;
      const address = {
        city: selectedAddress.city,
        nr: selectedAddress.houseNumber,
        localNr: selectedAddress.flatNumber,
        postCode: selectedAddress.postalCode,
        street: selectedAddress.street,
        terc:
          selectedAddress.woj.padStart(2, '0') +
          selectedAddress.pow.padStart(2, '0') +
          selectedAddress.gmi.padStart(2, '0')
      };
      this.schoolModel.schoolAddress.$setData(address);
    },

    // @vuese
    // Ustawia dane zespołu szkół
    setGroup(selectedSchool) {
      this.$store.dispatch('structureNode/get', selectedSchool.parentId).then(group => this.setSchoolData(group));
    },

    // @vuese
    // Czyści dane podszkoły
    clearSubschoolData() {
      this.schoolModel.subSchoolName.$setData(null);
      this.schoolModel.subSchoolId.$setData(null);
      this.schoolModel.schoolType.$setData(null);
      this.schoolModel.schoolTypeDescription.$setData(null);
      this.schoolModel.reportType.$setData(null);
      if (this.$schema.selectedSubschool) {
        this.$schema.selectedSubschool.$setData(null);
      }
    }
  }
};
